export class ContractReturnResponseModel {
    creditBalance: number;
    contractCanceled: string;
    disputeCase: string;
    code: string;
    message: string;

    constructor() {
        this.creditBalance = 0;
        this.contractCanceled = "";
        this.disputeCase = "";
        this.code = "";
        this.message = "";
    }
}